module.exports = __webpack_public_path__ + "static/media/FB_IMG_1454477365179.1bb3551a.jpg";